import React from "react";

import { PackagesReportController } from "../../../../services/controllers/reports";
import { usePackagesReport } from "../../../../store/reports/usePackagesReport";
import { formatMoney } from "../../../../services/functions";

import { Pagination } from "../../../../components/ui/Pagination";
import { Table } from "../../../../components/ui/Table";

const SORTABLE_COLUMN_KEYS = {
  Tutor: "customerName",
  Pet: "petName",
  CPF: "customerCpf",
  Telefone: "customerCellphone",
  Cadastro: "petCreatedAt",
  Pacotes: "totalPackages",
  "Banhos abertos": "bathOpens",
  "Adicionais abertos": "servicesOpens",
  "Último pacote": "lastPackage",
  Receita: "revenue",
};

export function PackagesReportTable() {
  const CPackagesReport = PackagesReportController();

  const page = usePackagesReport((st) => st.data.pagination.page);
  const paginationData = usePackagesReport((st) => st.data.pagination);
  const packages = usePackagesReport((st) => st.data.packagesReport);
  const sort = usePackagesReport((st) => st.data.sort);
  const isWaiting = usePackagesReport((st) => st.data.isWaiting);

  return (
    <Table.Root name={CPackagesReport.tableName} config>
      <Table.Header
        columns={[
          "Tutor:minmax(150px, 260px)",
          "Pet:minmax(105px, 200px)",
          "CPF:120px",
          "Telefone:115px",
          "Cadastro:105px",
          "Pacotes:90px",
          "Banhos abertos:115px",
          "Adicionais abertos:125px",
          "Último pacote:105px",
          "Receita:105px",
        ]}
        sortableConfig={{
          sortBy: sort.sortBy,
          sortOrder: sort.sortOrder,
          onSort: CPackagesReport.handleSortColumn,
          columnKeys: SORTABLE_COLUMN_KEYS,
        }}
      />

      <Table.Content isLoading={isWaiting}>
        {!!packages[page] &&
          packages[page].map((item) => (
            <Table.Line key={item.id}>
              <Table.Item title={item.customerName}>{item.customerName}</Table.Item>
              <Table.Item title={item.petName}>{item.petName}</Table.Item>
              <Table.Item>{item.cpfLabel}</Table.Item>
              <Table.Item>{item.cellphone}</Table.Item>
              <Table.Item>{item.petCreatedAt || "-"}</Table.Item>
              <Table.Item className="text-right">{item.totalPackages}</Table.Item>
              <Table.Item className="text-right">{item.bathOpens}</Table.Item>
              <Table.Item className="text-right">{item.servicesOpens}</Table.Item>
              <Table.Item>{item.lastPackage || "-"}</Table.Item>
              <Table.Item className="text-right">R$ {formatMoney(item.revenue)}</Table.Item>
            </Table.Line>
          ))}
      </Table.Content>

      <Pagination.Root
        name={CPackagesReport.paginationName}
        totalPages={paginationData.totalPages}
        currentPage={paginationData.page}
        onChange={CPackagesReport.setPage}
      >
        <Pagination.Back />
        <Pagination.Pages />
        <Pagination.Forward />
      </Pagination.Root>
    </Table.Root>
  );
}
